
// Random int between min and max
export default function randomIntBetween(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}



// WEBPACK FOOTER //
// ./website/vendor/scripts/fabrique/modules/random-int-between.js